import React, { useState } from 'react';
import Modal from '../../shared/components/UI/Modal/Modal';
import styles from './CookieSettingsModal.module.scss';

interface CookieSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
}

const CookieSettingsModal: React.FC<CookieSettingsModalProps> = ({
  isOpen,
  onClose,
  onSave,
}) => {
  const [analytics, setAnalytics] = useState(false);
  const [functional, setFunctional] = useState(false);
  const [advertising, setAdvertising] = useState(false);

  const handleSave = () => {
    onSave();
  };

  return (
    <Modal isOpen={isOpen} closeModal={onClose} className={styles['cookie-modal']}>
      <div className={styles['cookie-modal__content']}>
        <div className={styles['cookie-modal__header']}>
          <h2 className={styles['cookie-modal__title']}>Настройка cookie-файлов</h2>
          <p className={styles['cookie-modal__description']}>
            Вы можете выбрать, какие категории cookie-файлов мы можем использовать. 
            Обязательные cookie необходимы для работы сайта и не могут быть отключены.
          </p>
        </div>

        <div className={styles['cookie-modal__options']}>
          <div className={styles['cookie-option']}>
            <div className={styles['cookie-option__info']}>
             <div className={styles['cookie-option__header']}>
      <h3 className={styles['cookie-option__title']}>Обязательные cookie</h3>
      <div className={styles['cookie-option__necessarily']}>
        <span className={styles['cookie-option__necessarily_text']}>Всегда включены</span>
        <img className={styles['lock']} src="/lock.svg" alt="lock" />
      </div>
    </div>
              <p className={styles['cookie-option__description']}>
                Обеспечивающие базовую работу сайта, безопасность и сохранение ваших настроек. 
                Они включены всегда и не могут быть отключены.
              </p>
            </div>
          </div>

          <div className={styles['cookie-option']}>
            <div className={styles['cookie-option__info']}>
              <h3 className={styles['cookie-option__title']}>Аналитические cookie</h3>
              <p className={styles['cookie-option__description']}>
                Помогают собирать статистику о том, как пользователи используют сайт, чтобы мы могли его улучшать.
              </p>
            </div>
            <div className={styles['cookie-option__control']}>
              <label className={styles['toggle']}>
                <input type="checkbox" checked={analytics}onChange={() => setAnalytics(!analytics)}/>
                <span className={styles['toggle__slider']}></span>
              </label>
            </div>
          </div>

          <div className={styles['cookie-option']}>
            <div className={styles['cookie-option__info']}>
              <h3 className={styles['cookie-option__title']}>Функциональные cookie</h3>
              <p className={styles['cookie-option__description']}>
                Запоминают ваши настройки и предпочтения, чтобы сделать сайт удобнее.
              </p>
            </div>
            <div className={styles['cookie-option__control']}>
              <label className={styles['toggle']}>
                <input type="checkbox" checked={functional}onChange={() => setFunctional(!functional)}/>
                <span className={styles['toggle__slider']}></span>
              </label>
            </div>
          </div>

          <div className={styles['cookie-option']}>
            <div className={styles['cookie-option__info']}>
              <h3 className={styles['cookie-option__title']}>Рекламные и персонализированные cookie</h3>
              <p className={styles['cookie-option__description']}>
                Используются для показа рекламы и контента, которые могут быть вам более интересны.
              </p>
            </div>
            <div className={styles['cookie-option__control']}>
              <label className={styles['toggle']}>
                <input type="checkbox"  checked={advertising} onChange={() => setAdvertising(!advertising)}/>
                <span className={styles['toggle__slider']}></span>
              </label>
            </div>
          </div>
        </div>

        <div className={styles['cookie-modal__footer']}>
          <button className={styles['cookie-modal__btn--primary']} onClick={handleSave}>
            Сохранить
          </button>
        </div>
      </div>
    </Modal>
  );
};

export  {CookieSettingsModal};